import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconUIComponent } from '../icon/icon.component';
import { RatingStarType } from '../../../types/rating.type';

const STAR_COUNT = 5;

@Component({
  selector: 'fr8bot-ui-rating',
  imports: [IconUIComponent],
  templateUrl: './rating.component.html',
  styleUrl: './rating.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingUIComponent {
  readonly point = input<string | number>(0);
  readonly showPoint = input(false);

  readonly stars = computed<RatingStarType[]>(() => {
    const mark = Math.floor(Number(this.point()));

    return Array.from({ length: STAR_COUNT }, (_, index) =>
      index < mark ? 'start-fill' : 'start-border',
    );
  });
}
